export var radioSizes = {
  lg: 10,
  md: 10,
  sm: 10,
  xs: 6
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9SYWRpby9jb25maWcudHMiXSwibmFtZXMiOlsicmFkaW9TaXplcyIsImxnIiwibWQiLCJzbSIsInhzIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLElBQU1BLFVBQVUsR0FBRztBQUN4QkMsRUFBQUEsRUFBRSxFQUFFLEVBRG9CO0FBRXhCQyxFQUFBQSxFQUFFLEVBQUUsRUFGb0I7QUFHeEJDLEVBQUFBLEVBQUUsRUFBRSxFQUhvQjtBQUl4QkMsRUFBQUEsRUFBRSxFQUFFO0FBSm9CLENBQW5CIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHJhZGlvU2l6ZXMgPSB7XG4gIGxnOiAxMCxcbiAgbWQ6IDEwLFxuICBzbTogMTAsXG4gIHhzOiA2XG59XG4iXX0=